var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tag',{staticClass:"app-state-alert",attrs:{"type":_vm.type,"effect":"dark","size":"mini"}},[_vm._v("\n  "+_vm._s(_vm.$t(("STATE_ALERT." + _vm.value)))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }